import React from 'react';
import getOr from 'lodash/fp/getOr';
import styled from 'styled-components';
import { LoadingEllipses } from 'components/common/LoadingEllipses';

const getCurrentPage = getOr(0, 'pageInfo.currentPage');
const getTotalCount = getOr(0, 'totalCount');

interface SearchResultsPageInfoProps<TData> {
  searchKey?: string;
  data?: TData;
  perPage: number;
  color?: string;
  className?: string;
  children?: React.ReactNode;
}

export function SearchResultsPageInfo<TData>({
  searchKey = 'search',
  ...props
}: SearchResultsPageInfoProps<TData>) {
  const data = props.data && (props.data as any)[searchKey];
  if (!data) {
    return <LoadingEllipses />;
  }
  const currentPage = getCurrentPage(data);
  const totalCount = getTotalCount(data);
  let resultMax = currentPage * props.perPage;
  if (resultMax > totalCount) {
    resultMax = totalCount;
  }
  return (
    totalCount > 0 && (
      <StyledSearchResultsPageInfo
        color={props.color || 'inherit'}
        className={props.className}
      >
        Showing {(currentPage * props.perPage - 9).toLocaleString()}-
        {resultMax.toLocaleString()} of {totalCount.toLocaleString()}
        {props.children}
      </StyledSearchResultsPageInfo>
    )
  );
}

const StyledSearchResultsPageInfo = styled.h4.attrs(({ color }) => ({ color }))`
  font-family: var(--FONT_SERIF);
  font-weight: normal;
  font-size: 16px;
  color: ${({ color }) => color};
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0;
`;
